import { render, staticRenderFns } from "./ResourcesTable.vue?vue&type=template&id=33488184&"
import script from "./ResourcesTable.vue?vue&type=script&lang=js&"
export * from "./ResourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports